// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"2007b501","729":"ae5e60cc","770":"b6d60977","918":"858b5dab"}[chunkId] + ".chunk.js";
};